<template>
    <div class="modal_content">
        <button type="button" class="modal_content_close" @click="handleClose">
            <IconClose />
        </button>

        <FormulateForm
            v-model="formValues"
            ref="form"
            novalidate
            @submit="handleSubmit"
        >
            <div class="modal_content_container">
                <h2>Add promocode</h2>

                <div class="form_field">
                    <IconBarcode class="form_field_prefix" />
                    <FormulateInput
                        type="text"
                        name="promocode"
                        validation="required"
                        placeholder="Enter your promocode"
                    />
                </div>
                <FormulateInput
                    type="submit"
                    label="Add promocode"
                    class="submitButton"
                />
            </div>
        </FormulateForm>
    </div>
</template>

<script setup lang="ts">
import IconClose from '@/components/icons/IconClose.vue';
import IconBarcode from '@/components/icons/IconBarcode.vue';
import { ref } from 'vue';

interface FormValue {
    promocode: string | null;
}

const emit = defineEmits<{
    (e: 'handleSavePromocode', val: string | null): void;
    (e: 'handleCloseModal'): void;
}>();

const formValues = ref({
    promocode: null,
} as FormValue);

function handleSubmit(val: FormValue) {
    emit('handleSavePromocode', val.promocode);
    handleClose();
}

function handleClose() {
    emit('handleCloseModal');
}
</script>

<style lang="scss">
.modal_content {
  border-radius: 60px;
  width: 717px;
  padding: 68px 80px 70px;
  background-color: #ffffff;
  position: relative;

  @media screen and (max-width: 1540px) {
    width: 685px;
    padding: 55px 64px 64px;
    border-radius: 48px;
  }

  @media screen and (max-width: 1100px) {
    width: 520px;
    padding: 40px;
    border-radius: 30px;
  }

  @media screen and (max-width: 600px) {
    width: 420px;
  }

  @media screen and (max-width: 460px) {
    width: 320px;
  }

  &_container {
    h2 {
      color: #202020;
      font-family: "Bebas Neue Pro";
      font-size: 80px;
      font-style: normal;
      font-weight: 700;
      line-height: 100%;
      text-transform: uppercase;
      margin: 0;
      padding: 0 0 22px;
      @media screen and (max-width: 1540px) {
        font-size: 64px;
        padding: 0 0 20px;
      }
      @media screen and (max-width: 1100px) {
        font-size: 40px;
        padding: 0 0 36px;
      }
      @media screen and (max-width: 767px) {
        padding: 0 0 28px;
      }
    }
  }

  .submitButton {
    padding-top: 32px;
    padding-bottom: 0;

    @media screen and (max-width: 1540px) {
      padding-top: 34px;
    }
    @media screen and (max-width: 767px) {
      padding-top: 12px;
    }
  }

  &_close {
    border: none;
    outline: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-color: #ffffff;
    position: absolute;
    bottom: calc(100% + 16px);
    right: 0;

    @media screen and (max-width: 767px) {
      width: 56px;
      height: 56px;
      bottom: calc(100% + 8px);
    }
  }
}
</style>
